import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PreviewWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  height: 77vh;
  margin-right: ${Spacing.S12};
  border: 1px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Grey100};
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S4};
  margin-top: -${Spacing.S8};
`
